export enum FlatTypes {
  'Commercial' = 'Commercial',
  'Residential' = 'Residential',
  'Suite Room' = 'Suite Room',
  '1BHK' = '1BHK',
  '1.5BHK' = '1.5BHK',
  '2BHK' = '2BHK',
  '2.5BHK' = '2.5BHK',
  '3BHK' = '3BHK',
  '3.5BHK' = '3.5BHK',
  '4BHK' = '4BHK',
  '4.5BHK' = '4.5BHK',
  '5BHK' = '5BHK',
  '5.5BHK' = '5.5BHK',
  '4BHK + Home Theatre' = '4BHK + Home Theatre',
  '4BHK+Home Theatre-Duplex' = '4BHK+Home Theatre-Duplex',
  '3BHK+1(Home Theatre or Bedroom)' = '3BHK+1(Home Theatre or Bedroom)',
  '4BHK+1(Home Theatre or Bedroom)' = '4BHK+1(Home Theatre or Bedroom)',
  '4BHK + MULTIPURPOSE' = '4BHK + MULTIPURPOSE',
  '4BHK + MULTIPURPOSE+THEATRE' = '4BHK + MULTIPURPOSE+THEATRE',
  '5BHK+OFFICE+THEATRE+MULTIPURPOSE' = '5BHK+OFFICE+THEATRE+MULTIPURPOSE',
  '3BHK+2TOI' = '3BHK+2TOI',
  '3BHK+STUDY' = '3BHK+STUDY',
  '4bhk+4T' = '4bhk+4T',
  '4BHK + HT + Office + Staff' = '4BHK + HT + Office + Staff',
  '4BHK + Office + Staff' = '4BHK + Office + Staff',
  '4 BHK + STUDY + HOME THEATER' = '4 BHK + STUDY + HOME THEATER',
  '5bhk+5T+Servant' = '5bhk+5T+Servant',
  '5 BHK + HOME THEATER' = '5 BHK + HOME THEATER',
  '5 BHK + STUDY +HOME THEATER' = '5 BHK + STUDY +HOME THEATER',
  '2BHK+3T' = '2BHK+3T',
  '4BHK+MAID' = '4BHK+MAID',
  '3BHK+MAID' = '3BHK+MAID',
  '4 BHK+Tv lounge' = '4 BHK+Tv lounge',
  '6 BHK+Tv lounge' = '6 BHK+Tv lounge',
  '6BHK' = '6BHK',
  '3BHK+STUDY+MAID' = '3BHK+STUDY+MAID',
  '3BHK+HT+MAID' = '3BHK+HT+MAID',
  'STUDIO' = 'STUDIO',
  '4BHK + STUDY + STAFF' = '4BHK + STUDY + STAFF',
  '4BHK + STAFF' = '4BHK + STAFF',
  '4BHK + HOME THEATRE + STAFF' = '4BHK + HOME THEATRE + STAFF',
  '3BHK + STUDY + STAFF' = '3BHK + STUDY + STAFF',
  'TRIPLEX PENTHOUSE' = 'TRIPLEX PENTHOUSE',
  '1BHK+1T' = '1BHK+1T',
  '1BHK+IT+1BATH' = '1BHK+IT+1BATH',
  '2BHK+2T' = '2BHK+2T',
  '3B+2T' = '3B+2T',
  '3B+3T' = '3B+3T'
}
